import { put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { QuoteService } from 'services';
import { tableAction, tableActions, tableInitialState } from './Table.duck';
import { newMercureMessage } from './App.duck';

export const actionTypes = {
  RequestData: '[DashboardQuotesAgreement] RequestDashboardQuotesAgreement',
  FulfilledTable: '[DashboardQuotesAgreement] FulfilledDashboardQuotesAgreement',
  SearchTable: '[DashboardQuotesAgreement] Search DashboardQuotesAgreement',
  ChangePage: '[DashboardQuotesAgreement] change page',
  SetPageSize: '[DashboardQuotesAgreement] set page size',
  SortTable: '[DashboardQuotesAgreement] Sort DashboardQuotesAgreement',
  ApplyFilter: '[DashboardQuotesAgreement] Apply filter',
  RemoveFilter: '[DashboardQuotesAgreement] Remove filter',
  ResetFilters: '[DashboardQuotesAgreement] Reset filter',
};

const initialState = {
  ...tableInitialState,
  sortBy: { name: 'asc' },
};

export const reducer = (state = initialState, action) => {
  const newState = tableAction(actionTypes, state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export const actions = {
  ...tableActions(actionTypes),
};

export function* saga() {
  function* reloadData() {
    yield put(actions.requestData());
  }

  yield takeLatest(actionTypes.SearchTable, reloadData);
  yield takeLatest(actionTypes.ChangePage, reloadData);
  yield takeLatest(actionTypes.SetPageSize, reloadData);
  yield takeLatest(actionTypes.SortTable, reloadData);
  yield takeLatest(actionTypes.ApplyFilter, reloadData);
  yield takeLatest(actionTypes.RemoveFilter, reloadData);
  yield takeLatest(actionTypes.ResetFilters, reloadData);

  yield takeLatest(actionTypes.RequestData, function* requestDashboardQuotesAgreementSaga() {
    const currentTenantId = yield select(state => state.AppReducer.tenant.tenantId);
    const currentState = yield select(state => state.DashboardQuotesAgreementReducer);

    const response = yield QuoteService.getQuotes(
      currentTenantId,
      currentState.page,
      currentState.pageSize,
      { quotationNumber: 'desc' },
      { quoteStatus: ['sent', 'expired', 'reminded'] },
      undefined,
    );

    yield put(actions.fulfilled(response.data['hydra:member'], response.data['hydra:totalItems']));
  });

  yield takeEvery(newMercureMessage, function* execute(action) {
    if (typeof action.data['@type'] === 'string' && action.data['@type'] === 'Quote1') {
      yield put(actions.requestData());
    }
  });
}
